import {API_END_POINTS} from './ApiEndPonts';
import axiosHttp from './Axios';
import Result from './Results';
import ServerCommunicationInterceptors from './ServerCommunicationInterceptors';

// this service we are using for the call our interceptors, create response and error
export default class ServerCommunicationService {
  constructor() {
    this.ServerCommunicationInterceptorsRef =
      new ServerCommunicationInterceptors();
  }

  // get method
  getDataToServer = async obj => {
    try {
      const response = await this.ServerCommunicationInterceptorsRef.get({
        endPoint: obj?.endPoint,
        params: obj?.params,
      });
      switch (response.status) {
        case 200:
          return new Result().success(response);
        case 404:
          return new Result().info(response);
        case 401:
          return new Result().info(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error(response);
      }
    } catch (error) {
      switch (error.status) {
        case 200:
          throw new Result().setData(error);
        case 404:
          throw new Result().info(error);
        case 401:
          throw new Result().info(error);
        case 201:
          throw new Result().setData(error);
        default:
          throw new Result().error(error);
      }
    }
  };

  // post method
  postDataToServer = async obj => {
    try {
      const response = await this.ServerCommunicationInterceptorsRef.post({
        data: obj?.data,
        params: obj?.params,
        endPoint: obj?.endPoint,
        responseType: obj?.responseType ?? 'json',
      });
      console.log('POST RESPONSE:', response);
      switch (response.status) {
        case 200:
          return new Result().success(response);
        case 404:
          return new Result().info(response);
        case 401:
          return new Result().info(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error(response);
      }
    } catch (error) {
      switch (error.status) {
        case 200:
          throw new Result().setData(error);
        case 404:
          throw new Result().info(error);
        case 401:
          throw new Result().info(error);
        case 201:
          throw new Result().setData(error);
        default:
          throw new Result().error(error);
      }
    }
  };

  // patch method
  patchDataFromServer = async obj => {
    try {
      const response = await this.ServerCommunicationInterceptorsRef.patch({
        data: obj?.data,
        params: obj?.params,
        endPoint: obj?.endPoint,
        responseType: obj?.responseType ?? 'json',
      });
      switch (response.status) {
        case 200:
          return new Result().success(response);
        case 404:
          return new Result().info(response);
        case 401:
          return new Result().info(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error(response);
      }
    } catch (error) {
      switch (error.status) {
        case 200:
          throw new Result().setData(error);
        case 404:
          throw new Result().info(error);
        case 401:
          throw new Result().info(error);
        case 201:
          throw new Result().setData(error);
        default:
          throw new Result().error(error);
      }
    }
  };
  // put method
  putDataInServer = async obj => {
    try {
      const response = await this.ServerCommunicationInterceptorsRef.put({
        data: obj?.data,
        params: obj?.params,
        endPoint: obj?.endPoint,
      });
      switch (response.status) {
        case 200:
          return new Result().setData(response);
        case 404:
          return new Result().setData(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error('ERROR1', response.status, 'ERROR2');
      }
    } catch (error) {
      throw new Result().error('error', error, error.errorType);
    }
  };

  // delete method
  deleteDataFromServer = async obj => {
    try {
      const response = await this.ServerCommunicationInterceptorsRef.delete({
        data: obj?.data,
        params: obj?.params,
        endPoint: obj?.endPoint,
      });
      switch (response.status) {
        case 200:
          return new Result().setData(response);
        case 404:
          return new Result().setData(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error('ERROR1', response.status, 'ERROR2');
      }
    } catch {
      return new Result().error();
    }
  };

  // post method upload image
  uploadImageToServer = async obj => {
    console.log('??OBJECT UPLOAD IMAGE ??', obj);
    try {
      const formData = new FormData();
      formData.append('folder', obj?.bukketName);
      if (Array.isArray(obj?.images)) {
        obj?.images.forEach((image, index) => {
          formData.append('files', {
            uri: image?.uri || null,
            name: image.name || null,
            type: image.type || null,
          });
        });
      } else alert('error upload docs');

      for (let [key, value] of formData._parts) {
      }
      // const response = await this.ServerCommunicationInterceptorsRef.post({
      //   data: formData,
      //   endPoint: API_END_POINTS.uploadDocumets.END_POINT,
      // });
      const response = await axiosHttp.post(
        API_END_POINTS.uploadDocumets.END_POINT,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      switch (response?.status) {
        case 200:
          return new Result().success(response);
        case 404:
          return new Result().info(response);
        case 401:
          return new Result().info(response);
        case 201:
          return new Result().setData(response);
        default:
          return new Result().error(response);
      }
    } catch (error) {
      console.log('                            ');
      console.log('>>>error>>', error);
      console.log('                            ');
      return new Result().error(error.message || 'Unknown error');
    }
  };
}
